import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { map, Observable } from 'rxjs';
import { CurrentUser } from '../user/current-user';
import { CognitoAuth } from '../auth/cognito-auth';

/** Never put it on `/medinbox/load`: that route is what establishes the equipment Cognito session. */
export const equipmentGuard: CanActivateFn = (): Observable<boolean | UrlTree> | UrlTree => {
  const userService = inject(CurrentUser);
  const cognitoAuthService = inject(CognitoAuth);
  const router = inject(Router);

  if (!userService.isEquipment()) {
    return router.parseUrl('/');
  }

  return cognitoAuthService.isLoggedIn().pipe(map((isLoggedIn) => (isLoggedIn ? true : router.parseUrl('/'))));
};
